var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultBulkEditCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7881 16.9139L7.30278 8.42867L8.21191 7.51953L16.6972 16.0048L15.7881 16.9139Z",
    fill: "#111213"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6972 8.42776L8.21187 16.913L7.30273 16.0039L15.788 7.51863L16.6972 8.42776Z",
    fill: "#111213"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultBulkEditCancelIcon);
export default __webpack_public_path__ + "static/media/vault-bulk-edit-cancel-icon.a6c8815cd180bcc684f967fabc51f850.svg";
export { ForwardRef as ReactComponent };